import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ElectricPlugIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M5.75 1C5.33579 1 5 1.33579 5 1.75V5H3.5C3.22386 5 3 5.22386 3 5.5V6C3 6.27614 3.22386 6.5 3.5 6.5H4V9C4 10.1046 4.89543 11 6 11H10C11.1046 11 12 10.1046 12 9V6.5H12.5C12.7761 6.5 13 6.27614 13 6V5.5C13 5.22386 12.7761 5 12.5 5H11V1.75C11 1.33579 10.6642 1 10.25 1C9.83579 1 9.5 1.33579 9.5 1.75V5H6.5V1.75C6.5 1.33579 6.16421 1 5.75 1Z"
			></path>
			<path
				fill="currentColor"
				d="M13.2321 13.4391C13.3986 13.0229 13.8017 12.75 14.25 12.75C14.6642 12.75 15 12.4142 15 12C15 11.5858 14.6642 11.25 14.25 11.25C13.1884 11.25 12.2337 11.8963 11.8394 12.8821L11.8036 12.9715C11.6156 13.4417 11.1601 13.75 10.6537 13.75H10.3852C9.48209 13.75 8.75 13.0179 8.75 12.1148V12H7.25V12.1148C7.25 13.8463 8.65366 15.25 10.3852 15.25H10.6537C11.7735 15.25 12.7805 14.5682 13.1964 13.5285L13.2321 13.4391Z"
			></path>
		</svg>
	),
)
